import { TUNING, UNIT_TYPES } from './Game/definitions.js'

export default class WaveUI
{
    constructor(_options)
    {
        this.state = _options.state
        this.onStart = _options.onStart
        this.onDismiss = _options.onDismiss
        this.startButton = document.querySelector('.js-wave-start')
        this.status = document.querySelector('.js-wave-status')
        this.statusText = document.querySelector('.js-wave-status-text')
        this.healthFill = document.querySelector('.js-obelisk-health')
        this.result = document.querySelector('.js-wave-result')
        this.resultTitle = document.querySelector('.js-wave-result-title')
        this.resultDescription = document.querySelector('.js-wave-result-description')
        this.resultButton = document.querySelector('.js-wave-result-close')
        this.mastery = document.querySelector('.js-mastery')
        this.army = document.querySelector('.js-army-summary')
        this.focusedResult = null
        this.startButton.addEventListener('click', () => this.onStart())
        this.resultButton.addEventListener('click', () =>
        {
            this.state.dismissWaveResult()
            this.onDismiss()
            this.update()
        })
        this.result.addEventListener('keydown', (_event) =>
        {
            if(['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'KeyW', 'KeyA', 'KeyS', 'KeyD'].includes(_event.code))
                _event.stopPropagation()
        })
    }

    update()
    {
        const wave = this.state.wave
        const canStart = this.state.canStartWave()
        this.startButton.hidden = !canStart || Boolean(wave.result)
        if(canStart)
        {
            const retry = wave.status === 'defeat'
            this.startButton.textContent = `${retry ? 'RETRY' : 'START'} WAVE ${this.state.completedWaves + 1}`
        }
        this.status.hidden = !wave.active
        this.result.hidden = wave.active || !wave.result
        if(wave.active)
        {
            this.statusText.textContent = `WAVE ${wave.number}  •  ${wave.enemies.length} REMAIN`
            const ratio = Math.max(0, wave.obeliskHealth / TUNING.obeliskHealth)
            this.healthFill.style.transform = `scaleX(${ratio})`
        }
        if(wave.result)
        {
            if(this.focusedResult !== wave.result.number)
            {
                this.focusedResult = wave.result.number
                this.resultButton.focus()
            }
            this.resultTitle.textContent = wave.result.victory ? 'THE DEAD PREVAIL' : 'THE RITUAL FALTERS'
            let description = wave.result.victory ? 'A new ritual has been revealed.' : 'Your base is unharmed. Re-raise the fallen and retry whenever ready.'
            if(wave.result.victory && wave.result.number >= 9)
                description = wave.result.number === 9 ? 'The Lich Altar is revealed. Endless waves now await.' : `Dark Mastery rises to rank ${wave.result.mastery}.`
            this.resultDescription.textContent = description
        }
        else
            this.focusedResult = null
        this.mastery.hidden = this.state.mastery === 0
        this.mastery.textContent = `DARK MASTERY ${this.state.mastery}`
        const guards = this.state.unitCount('guard') + this.state.unitCount('brute')
        const ranged = this.state.unitCount('archer') + this.state.unitCount('lich')
        const workers = this.state.units.filter((_unit) => UNIT_TYPES[_unit.type].role !== 'combat').length
        this.army.textContent = `${guards} FRONTLINE  •  ${ranged} RANGED  •  ${workers} WORKERS`
    }
}
